var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Expired',{attrs:{"title":_vm.$t('payment.error_title'),"text":_vm.$t('payment.error_text')}})
}
var staticRenderFns = []

export { render, staticRenderFns }